import axios from 'axios'
import store from '@/store'
import Vue from 'vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)




const addErrorLog = errorInfo => {
const { statusText, status, request: { responseURL } } = errorInfo
let info = {
type: 'ajax',
code: status,
mes: statusText,
url: responseURL
}
if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
constructor (baseUrl = baseURL) {
this.baseUrl = baseUrl
this.queue = {}
}
getInsideConfig () {
const config = {
baseURL: this.baseUrl,
headers: {
"auth-identity":store.state.user.token
}
}
return config
}
destroy (url) {
delete this.queue[url]
if (!Object.keys(this.queue).length) {

}
}
interceptors (instance, url) {

instance.interceptors.request.use(config => {

if (!Object.keys(this.queue).length) {

}
this.queue[url] = true
return config
}, error => {
return Promise.reject(error)
})

instance.interceptors.response.use(res => {
this.destroy(url)
const { data, status } = res
if(status==200)
{
if(data.code!==200)
{
Vue.$vux.alert.show({
title: '错误!',
content: data.msg,
onShow () {
console.log('Plugin: I\'m showing')
},
onHide () {
console.log('Plugin: I\'m hiding')
}
})
}
}else{
Vue.$vux.alert.show({
title: '错误',
content: `状态码【${status}】`,
onShow () {
console.log('Plugin: I\'m showing')
},
onHide () {
console.log('Plugin: I\'m hiding')
}
})
}
return { data, status }
}, error => {
this.destroy(url)
let errorInfo = error.response
if (!errorInfo) {
const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
errorInfo = {
statusText,
status,
request: { responseURL: config.url }
}
}
addErrorLog(errorInfo)
return Promise.reject(error)
})
}
request (options) {
const instance = axios.create()
options = Object.assign(this.getInsideConfig(), options)
this.interceptors(instance, options.url)
return instance(options)
}
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js